
import { mapGetters,mapActions } from 'vuex'
export default {
 name: "Tab",
 props: {
    id: {
      default: '',
      type: String,
    },
    active: {
      default: '',
      type: String,
    },
 },
 data() {
    return {
      startActive: this.active !== '',
    }
  },
  computed: {
    ...mapGetters({
      activeTab : 'pages/getActiveTab' || this.id,
    }),
  },
  methods: {
    ...mapActions({
      updateActiveTab: 'pages/updateActiveTab', // map `this.add()` to `this.$store.commit('increment')`
    }),
    updateTab(){
      this.startActive = false
      this.updateActiveTab(this.id)
      console.log('Active Tab: ',this.activeTab)
      /*
      this.$nextTick(() => {
        const element = document.getElementById('content_' + this.id)
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      })
      */
    }
  },

}
